import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { EFilterType, EStrategy, IFilterParams, IFilterTextOption } from '../filter.type';

@Component({
  selector: 'bixi-filter-advance-text',
  template: `
    <nz-form-item>
      <nz-form-control [nzSpan]="24">
        <nz-input-group [nzSuffix]="suffixIconSearch">
          <input
            type="text" nz-input
            [disabled]="option.disabled"
            [(ngModel)]="filterParams[option.key]"
            [placeholder]="option.placeholder"
            (ngModelChange)="onInput()"
            (keyup.enter)="onEnter()"
            (blur)="onBlur()"
          />
        </nz-input-group>
        <ng-template #suffixIconSearch>
          <i nz-icon [ngStyle]="{ cursor: 'pointer' }" (click)="onSearchIconClick()" nzType="search"></i>
        </ng-template>
      </nz-form-control>
    </nz-form-item >
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterAdvanceTextComponent {
  @Input() option: IFilterTextOption;
  @Input() filterParams: IFilterParams;
  @Output() valueChange = new EventEmitter<{ mode: EStrategy, type: EFilterType, value: string }>();

  onModelChange(mode: EStrategy) {
    this.valueChange.emit({ mode, type: EFilterType.text, value: this.filterParams[this.option.key] as string });
  }

  onInput() {
    this.onModelChange(EStrategy.normal);
  }

  onEnter() {
    this.onModelChange(EStrategy.onEnter);
  }

  onBlur() {
    this.onModelChange(EStrategy.onBlur);
  }

  onSearchIconClick() {
    this.onModelChange(EStrategy.onSearchIconClick);
  }
}
